import React from 'react';
import { FiPhoneCall } from 'react-icons/fi';
import SafeIcon from '../SafeIcon';
import { motion } from 'framer-motion';

const FloatingPhone = () => {
  return (
    <motion.a
      href="tel:5145551234"
      className="fixed bottom-6 right-6 z-50 bg-accent text-white p-4 rounded-full shadow-lg hover:bg-accentHover hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 1, type: 'spring', stiffness: 200 }}
      aria-label="Call Now"
    >
      <SafeIcon icon={FiPhoneCall} className="text-2xl animate-pulse group-hover:animate-none" />
      <span className="absolute right-full mr-4 bg-gray-900 text-white text-sm py-1 px-3 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Call for Emergency Service (Demo)
      </span>
    </motion.a>
  );
};

export default FloatingPhone;